import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose, lifecycle, withHandlers } from 'recompose';
import List from './components/List';
import withFetchTaxes from './withFetchTaxes';

const mapStateToProps = (state, ownProps) => ({
  taxes: state.settings.taxes,
  baseUrl: ownProps.location.pathname.replace(/\/$/, ''),
  barberUser: state.auth.barberUser,
});

export default compose(
  withRouter,
  withFetchTaxes,
  connect(mapStateToProps),
  withHandlers({
    onEditTax: props => taxId => props.router.push(`${props.baseUrl}/${taxId}/edit`),
  }),
  lifecycle({
    componentDidMount() {
      this.props.fetchTaxes();
    },
  })
)(List);
